export const transportationOptions = [
  {
    id: 'plane',
    label: I18n.t('web.me.trips.form.transportation.plane'),
  },
  {
    id: 'train',
    label: I18n.t('web.me.trips.form.transportation.train'),
  },
  {
    id: 'subway',
    label: I18n.t('web.me.trips.form.transportation.subway'),
  },
  {
    id: 'bike',
    label: I18n.t('web.me.trips.form.transportation.bike'),
  },
  {
    id: 'feet',
    label: I18n.t('web.me.trips.form.transportation.feet'),
  },
  {
    id: 'car',
    label: I18n.t('web.me.trips.form.transportation.car'),
  },
  {
    id: 'other',
    label: I18n.t('web.me.trips.form.transportation.other'),
  },
];
